<template>
  <div>
    <redtaiTab v-model="tabName" @input="input" :list="list" />
    <div v-if="this.tabName == '报警记录'">
      <Callthepolice
        ref="Callthepolice"
        :graphDeviceComponentId="graphDeviceComponentId"
        :curId="curId"
      />
    </div>
    <div v-if="this.tabName == '润滑点台账'">
      <StandingBook
        ref="StandingBook"
        :groupAuthorityString="groupAuthorityString"
        :curId="curId"
        :getLists="getLists"
      />
    </div>
    <div v-if="this.tabName == '诊断报告'">
      <Diagnosticreport
        ref="Diagnosticreport"
        :diagnosticReportList="diagnosticReportList"
        :curId="curId"
        :getLists="getLists"
        :char="char"
        :oilSiteModelVOList="oilSiteModelVOList"
      />
    </div>
  </div>
</template>

<script>
import redtaiTab from "@/components/redtai-tab/index";
import Callthepolice from "./callthepolice";
import StandingBook from "./rhdetail-standBook";
import Diagnosticreport from "./Diagnosticreport";
import toRoleName from "@/mixins/roleName";
import ls from "store2";
import Base64 from "@/util/encryptlong";

export default {
  mixins: [toRoleName],
  props: [
    "graphDeviceComponentId",
    "diagnosticReportList",
    "curId",
    "alarmStatus",
    "char",
    "oilSiteModelVOList",
    "getLists",
    "rhtbIndex",
    "groupAuthorityString",
  ],
  components: {
    redtaiTab,
    Callthepolice,
    StandingBook,
    Diagnosticreport,
  },

  data() {
    return {
      tabvalue: 0,
      tabName: "报警记录",
      callpoecolumns: [],
      callpoedata: [],
      list: ["报警记录", "诊断报告"],
      userRole: null,
      userInfo: JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
    };
  },
  watch: {
    tabvalue(value) {},
    rhtbIndex() {
      this.tabgetlist();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    tabgetlist() {
      if (this.rhtbIndex > 2) {
        if (this.tabName == "报警记录") {
          this.$refs["Callthepolice"].getWarningLists();
        } else if (this.tabName == "润滑点台账") {
          this.$refs["StandingBook"].getStandBookList();
        } else {
          this.$refs["Diagnosticreport"].getLists();
        }
      }
    },
    init() {
      this.userRole = this.userInfo.authority;
      const role = this.toRoleName(this.userRole);
      if (this.userRole) ls.set("userRole", role);

      // 查看权限 美孚员工，美孚管理员，客户管理员，客户普通员，经销商管理员，经销商普通用户
     
        this.list.splice(1, 0, "润滑点台账");
     
    },
    input(item) {
      this.tabName = item.string;
    },
  },
};
</script>